
$(document).ready(function(){
  $('.synergy_anchor_thumb').on('click',function(e){
    var sy_data = $(this).attr('data-media');
    $('.synergy_media').hide();
    $( ".synergy_media" ).each(function( index ) {
      var sy_data_2 = $(this).attr('data-media');
      if(sy_data_2 == sy_data){
      	$(this).show();
      }
    });
   
    $(".product-images .synergy_image_thumb").removeClass("active-thumb");
    $(this).closest(".synergy_image_thumb").addClass("active-thumb");
    
  });

  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  
  $('.lightbox[rel="product-lightbox"]').fancybox();
  
  $('.home-testomonials').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});


// go to review for template new
$('#goToReview').click(function(e){
  e.preventDefault();
  if($(window).width() > 767){
    $('a[href="#tabs-6"]').trigger('click');
    var topScroll = $("#tabs-6").offset().top - 300;
    $('html, body').animate({
      scrollTop: (topScroll)
    }, 1500);
  } else {
    if(!$('a[href="#collapse6"]').hasClass('panelactive')){
      $('a[href="#collapse6"]').trigger('click'); 
    }
    var topScroll = $("#collapse6").offset().top - 200;
    $('html, body').animate({
      scrollTop: (topScroll)
    }, 1500);
  }
});

// jquery UI tabs 

  $( function() {
    $( "#tabs" ).tabs();
  } );

    if ($('.fancybox').length) {
      $('.fancybox').fancybox();
      $('body').on('click', '.glass', function(){
        var data_index = $('.slider-nav-thumbnails').find('.slick-current').data('slide-index');
        $(".product-featured-images-wrapper a[data-index-slide='" + data_index + "']").trigger('click');
      });
    }

 $( function() {
//var docPoc = $(document).height() - $(".site-header").outerHeight() - $(".product-new-template .product-page").outerHeight() + $(window).height();
 $(window).scroll(function() {
	var scorllPos=$(this).scrollTop();
	if( scorllPos > 500   ) {
		$(".sticky-cart-wrapper").show();
	}
	else {
	$(".sticky-cart-wrapper").hide();
	}
 });
 });


/*
$(".cart-button-wrapper button#AddToCart").hover(
  function () {
    $(this).addClass("animated bounce");
  },
  function () {
    $(this).removeClass("animated bounce");
  }
);
*/